<template>
  <div>
    <div class="row">
      <div class="col-sm-4">
        <custom-input
          :label="`Number of stores ${stepType === 'trial' ? 'for the test' : 'equipped with Kodak units'}`"
          :value="storesNumber"
          @input="$store.commit('changeStoresNumber2', $event)"
        />
      </div>
      <div class="col-sm-4">
        <custom-input
          label="Software Version"
          :value="software"
          @input="$store.commit('changeSoftware', $event)"
        />
      </div>
      <div class="col-sm-4">
        <div class="form-group">
          <label class="custom-label">Units on RBM</label>
          <br>
          <div class="form-check form-check-inline">
            <input class="form-check-input" type="radio" id="rbm1" value="1"
              :checked="rbm == '1'"
              @change="$store.commit('changeRbm', '1')"
            >
            <label class="form-check-label" for="rbm1">Yes</label>
          </div>
          <div class="form-check form-check-inline">
            <input class="form-check-input" type="radio" id="rbm2" value="0"
              :checked="rbm == '0'"
              @change="$store.commit('changeRbm', '0')"
            >
            <label class="form-check-label" for="rbm2">No</label>
          </div>
        </div>
        </div>
    </div>
    <div class="row" v-if="stepType === 'rollOut'">
      <div class="col-sm-4">
        <custom-input
          :label="`Number of total printing devices`"
          :value="printingDevices"
          @input="$store.commit('changePrintingDevices', $event)"
        />
      </div>
    </div>

    <div class="form-group">
      <label class="custom-label">Equipment</label>
      <br>
      <custom-checkbox
        label="APEX"
        value="apex"
        :checked="equipment.includes('apex')"
        @input="$store.commit('changeEquipment', $event)"
      />
      <custom-checkbox
        label="KIOSK"
        value="kiosk"
        :checked="equipment.includes('kiosk')"
        @input="$store.commit('changeEquipment', $event)"
      />
      <custom-checkbox
        label="Standalone"
        value="standalone"
        :checked="equipment.includes('standalone')"
        @input="$store.commit('changeEquipment', $event)"
      />
    </div>

    <div class="accordion" id="accordion">
      <apex-form :apex="apex" v-if="equipment.includes('apex')" />
      <kiosk-form :kiosk="kiosk" v-if="equipment.includes('kiosk')" />
      <standalone-form :standalone="standalone" v-if="equipment.includes('standalone')" />
    </div>

    <div style="margin-top: 1em;" v-if="nav">
      <button type="button" class="btn btn-primary float-left"
        @click="$router.push(`/${stepType === 'trial' ? 'trials' : 'roll_outs'}/create/2`)"
        v-text="'Back'"
      />
      <button type="button" class="btn btn-primary float-right"
        @click="$router.push(`/${stepType === 'trial' ? 'trials' : 'roll_outs'}/create/4`)"
        v-text="'Next'"
      />
    </div>
    <template v-else>
      <button class="btn btn-primary float-right"
        v-if="isAdmin || isFromAuthUser"
        @click.prevent="$emit('update')"
        style="margin-bottom: 1em;"
      >
        <i class="fa fa-edit"></i> Save
      </button>
    </template>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import StepMixin from './step-mixin'

  export default {
    mixins: [ StepMixin ],
    data() {
      return {
      }
    },
    computed: {
      ...mapState(['equipment', 'apex', 'kiosk', 'standalone', 'storesNumber', 'software', 'rbm', 'printingDevices']),
    },
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// resources/js/components/trials/CreateStep3.vue